import VParallax from './VParallax';

VParallax.install = function install(Vue) {
  Vue.component(VParallax.name, VParallax);
};

export default VParallax;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VParallax/index.js
// module id = mLW2
// module chunks = 0